angular.module('rjmNg.directives').directive "adobeAnalyticsReportSuiteList", [
  () ->
    restrict: "E"
    templateUrl: "directive.adobeAnalyticsReportSuiteList.html"
    controllerAs: "view"
    bindToController: true
    scope:
      connection: "<"
    controller: [
      "AdobeAnalytics"
      "dataWarehouseTablePath"
      "notification"
      (
        AdobeAnalytics
        dataWarehouseTablePath
        notification
      ) ->

        view = @

        view.generateTablePath = dataWarehouseTablePath.generateTablePath

        localTables = {}
        tables = {}
        _localTableNames = {}

        view.isLoading = true
        view.reportSuites = []

        @$onInit = () ->
          AdobeAnalytics.fetchLocalTableNames(
            view.connection.meta_id
          ).then( (success) ->
            view.reportSuites = AdobeAnalytics.parseReportSuites(view.connection)
          ).catch( (error) ->
            notification.error(
              "Error",
              "There was a problem loading Local Table Names information.",
              "adobe-analytics-integration"
            )
          ).finally( () ->
            view.isLoading = false
          )

        return view
    ]
]
